import React from 'react'
import { Radio } from 'antd'
import PropTypes from 'prop-types'

const ChecRadio = ({
  disabled,
  checked,
  onClick,
  children,
  group,
  name,
  defaultValue,
  value,
}) =>
  group ? (
    <Radio.Group
      onClick={onClick}
      name={name}
      value={value}
      defaultValue={defaultValue}
    >
      {children.map(({ value, display }, index) => (
        <Radio value={value} key={`${value}${display}${index}`}>
          {display || value}
        </Radio>
      ))}
    </Radio.Group>
  ) : (
    <Radio
      checked={checked}
      disabled={disabled}
      onClick={onClick}
      value={value}
    >
      {children}
    </Radio>
  )

ChecRadio.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  group: PropTypes.bool,

  onClick: PropTypes.func,

  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
  ]),

  name: PropTypes.string,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
}

export default ChecRadio
